import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import '../styles/Header.css';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
    setIsMobileMenuOpen(false);
    document.body.classList.remove('menu-open');
  }, [location.pathname]);

  const handleNavClick = () => {
    setIsMobileMenuOpen(false);
    document.body.classList.remove('menu-open');
  };

  const openCalendly = () => {
    if (!window.Calendly) {
      const script = document.createElement('script');
      script.src = 'https://assets.calendly.com/assets/external/widget.js';
      script.async = true;
      document.body.appendChild(script);

      script.onload = () => {
        initCalendly();
      };
    } else {
      initCalendly();
    }
  };

  const initCalendly = () => {
    if (window.Calendly) {
      window.Calendly.initPopupWidget({
        url: 'https://calendly.com/leighton-jacobus',
        prefill: {},
        text: 'Schedule a Call',
        color: '#8B5CF6',
        branding: true,
        hideEventTypeDetails: false,
        hideGdprBanner: true,
        backgroundColor: '#111827',
        textColor: '#ffffff',
        primaryColor: '#8B5CF6'
      });
    }
  };

  return (
    <header className={`header ${isScrolled ? 'scrolled' : ''}`}>
      <div className="header-container">
        <Link to="/" className="logo" onClick={handleNavClick}>
          <img 
            src="/CandIWhiteLogo.svg" 
            alt="Cause and Impact Logo" 
            className="logo-image"
          />
          <h1>
            <span className="logo-text">Cause</span>
            <span className="logo-separator-wrapper">
    <span className="logo-separator">&</span>
  </span>
              <span className="logo-text">Impact</span>
          </h1>
        </Link>

        <button 
          className={`mobile-menu-button ${isMobileMenuOpen ? 'active' : ''}`}
          onClick={() => {
            setIsMobileMenuOpen(!isMobileMenuOpen);
            document.body.classList.toggle('menu-open');
          }}
          aria-label="Toggle menu"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>

        <nav className={`main-nav ${isMobileMenuOpen ? 'open' : ''}`}>
          {isMobileMenuOpen && (
            <button 
              className="mobile-nav-close"
              onClick={() => setIsMobileMenuOpen(false)}
              aria-label="Close menu"
            />
          )}
          <ul>
            <li><Link to="/" onClick={handleNavClick} className={location.pathname === '/' ? 'active' : ''}>Home</Link></li>
            <li><Link to="/our-story" onClick={handleNavClick} className={location.pathname === '/our-story' ? 'active' : ''}>Our Story</Link></li>
            <li><Link to="/leadership" onClick={handleNavClick} className={location.pathname === '/leadership' ? 'active' : ''}>Behind The Scenes</Link></li>
            <li><Link to="/services" onClick={handleNavClick} className={location.pathname === '/services' ? 'active' : ''}>Services</Link></li>
            <li><Link to="/causes" onClick={handleNavClick} className={location.pathname === '/causes' ? 'active' : ''}>Causes</Link></li>
            <li><Link to="/cost-calculator" onClick={handleNavClick} className={location.pathname === '/cost-calculator' ? 'active' : ''}>501(c)(3) Cost Calculator</Link></li>
            <li><Link to="/academy" onClick={handleNavClick} className={location.pathname === '/academy' ? 'active' : ''}>Impact Academy</Link></li>
            <li>
              <button 
                onClick={openCalendly}
                className="schedule-call-button"
              >
                <span>Talk to Our Team</span>
              </button>
            </li>
            <li><Link to="/portal" onClick={handleNavClick} className="portal-button">Cause Portal</Link></li>
            <li><Link to="/donate" onClick={handleNavClick} className="donate-button">Donate</Link></li>
            <li><Link to="/apply" onClick={handleNavClick} className="apply-button">Apply Now</Link></li>
          </ul>
        </nav>

        <nav className="vertical-nav">
          <div className="tab-trigger">≡</div>
          <div className="vertical-menu">
            <ul>
              <li><Link to="/" className={location.pathname === '/' ? 'active' : ''}>Home</Link></li>
              <li><Link to="/our-story">Our Story</Link></li>
              <li><Link to="/leadership">Behind The Scenes</Link></li>
              <li><Link to="/services">Services</Link></li>
              <li><Link to="/causes">Causes</Link></li>
              <li><Link to="/cost-calculator">501(c)(3) Cost Calculator</Link></li>
              <li><Link to="/academy">Impact Academy</Link></li>
              <li>
                <button 
                  onClick={openCalendly}
                  className="schedule-call-button"
                >
                  Talk to Our Team
                </button>
              </li>
              <li><Link to="/portal" className="portal-button">Cause Portal</Link></li>
              <li><Link to="/donate" className="donate-button">Donate</Link></li>
              <li><Link to="/apply" className="apply-button">Apply Now</Link></li>
            </ul>
          </div>
        </nav>
      </div>
    </header>
  );
};

export default Header;
